module.exports = __webpack_public_path__ + "static/Carly_Daniel4-13da43587d1f8aba82095fc681ef60a4.jpg";